import { render, staticRenderFns } from "./CreaAggregazione.vue?vue&type=template&id=99bb5c2a&"
import script from "./CreaAggregazione.vue?vue&type=script&lang=js&"
export * from "./CreaAggregazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports